import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { Brands } from './shared/brands/brands-list';

@Component({
  selector: 'tf-settings-page-brands',
  imports: [CommonModule, Brands, TranslateModule],
  templateUrl: './settings-brands.component.html',
  styleUrl: './settings-brands.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrandsSettings {}
